export const WRONG_DATA_ERROR = "Неверные данные";
export const NETWORK_ERROR = "Произошла ошибка при запросе";
export const FILE_MAX_SIZE_ERROR = "Размер файла (файлов) не должен превышать 30 Мб";
